import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext({ language: 'kk', setLanguage: () => {} });

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => localStorage.getItem('preferred_language') || 'kk');

  const setLanguage = useCallback((lang) => {
    localStorage.setItem('preferred_language', lang);
    setLanguageState(lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const dateLocale = (language) => (language === 'kk' ? 'kk-KZ' : 'ru-RU');

const SERVICE_TYPE_NAMES = {
  emergency_service: { kk: 'ТЖ қызметі', ru: 'Служба ЧС' },
  municipal_service: { kk: 'ТКШ бөлімі', ru: 'Отдел ЖКХ' },
  architecture_service: { kk: 'Сәулет бөлімі', ru: 'Отдел Архитектуры' },
  heating_service: { kk: 'Жылу орталығы', ru: 'Теплоцентраль' },
  electricity_service: { kk: 'ОЭСК', ru: 'ОЭСК' },
  telecom_service: { kk: 'Қазақтелеком', ru: 'Казахтелеком' },
  traffic_police_service: { kk: 'ЖАИ', ru: 'ГАИ' },
  police_service: { kk: 'Полиция', ru: 'Полиция' },
  improvement_service: { kk: 'Абаттандыру қызметі «Зырян Тәртіп»', ru: 'Служба благоустройства «Зырян Тәртіп»' },
  education_service: { kk: 'Білім бөлімі', ru: 'ГОРОНО' },
  culture_sport_service: { kk: 'Мәдениет және спорт бөлімі', ru: 'Отдел Культуры и Спорта' },
  waste_service: { kk: 'ШемКомХоз', ru: 'ШемКомХоз' },
  healthcare_service: { kk: 'Денсаулық сақтау', ru: 'Горздрав' },
  lighting_service: { kk: 'Көше жарығы', ru: 'Уличное освещение' }
};

export const serviceTypeName = (serviceType, language, fallback = '') => {
  return SERVICE_TYPE_NAMES[serviceType]?.[language] || fallback;
};

const ADMIN_NAMES_KK = {
  'Системный администратор': 'Жүйе әкімшісі',
  'Аким города Алтай': 'Алтай қаласының әкімі'
};

export const adminDisplayName = (fullName, language) => {
  if (language === 'kk' && ADMIN_NAMES_KK[fullName]) return ADMIN_NAMES_KK[fullName];
  return fullName;
};
